import Api from '@/api'

export default {
  namespaced: true,
  state: {
    templates: [],
    templatesMeta: null,
    template: null,
    providers: [],
  },

  getters: {
    templates(state) {
      return state.templates
    },
    templatesMeta(state) {
      return state.templatesMeta
    },
    template(state) {
      return state.template
    },
    providers(state) {
      return state.providers
    },
  },

  mutations: {
    setTemplates(state, templates) {
      state.templates = templates
    },

    setTemplatesMeta(state, templatesMeta) {
      state.templatesMeta = templatesMeta
    },

    clearTemplates(state) {
      state.templates = null
    },

    setTemplate(state, template) {
      state.template = template
    },

    setProviders(state, providers) {
      state.providers = providers
    },
  },

  actions: {
    async getTemplates({ commit }, params) {
      commit('clearTemplates')
      const { data } = await Api.get(`templates`, { params: params })
      commit('setTemplates', data.data)
      commit('setTemplatesMeta', data.meta)
    },

    async getTemplate({ commit }, id) {
      const { data } = await Api.get(`templates/${id}`)
      commit('setTemplate', data.data)
    },

    async getProviders({ commit }, id) {
      const { data } = await Api.get(`templates/${id}/licence-provider`)
      commit('setProviders', data.data)
      commit('setTemplate', data.template)
    },
  },
}
